import { useTranslation } from "next-i18next"

const useTranslations = () => {
  const { t } = useTranslation()

  return {
    feedBackTitle: t("kf.pdp.label.feedBackTitle"),
  }
}

export default useTranslations
